(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["program-section-slider"] && !Shopify.designMode) return;
  try {
    
function initProgramSlider() {
  if (window.programSwiper) {
    window.programSwiper.destroy(true, true);
  }
  
  var sliderEl = document.querySelector('.program-slider');
  if (sliderEl) {
    window.programSwiper = new Swiper(sliderEl, {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 20,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        1199: { slidesPerView: 1.6 },
        768: { slidesPerView: 1 }
      }
    });
  }
}

// Shopify theme editor events
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', initProgramSlider);
  document.addEventListener('shopify:section:unload', function(){
    if (window.programSwiper) {
      window.programSwiper.destroy(true, true);
    }
  });
  document.addEventListener('shopify:block:select', initProgramSlider);
  document.addEventListener('shopify:block:deselect', initProgramSlider);
}

document.addEventListener('DOMContentLoaded', initProgramSlider);

  } catch(e) { console.error(e); }
})();
})();
